<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/12-IP-navigate-the-interview-with-ease.svg"
                class="img-fluid"
                alt="Navigate the interview with ease"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--interview-prep-02">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-8 p-4">
          <p>Even if you’re nervous, make your best effort to come into the interview with a positive attitude.</p>
          <p>Here are some tips for navigating the interview:</p>
          <div class="carousel">
            <hooper
              ref="carousel_01"
              class="mb-4"
            >
              <slide>
                <div class="slide">
                  <p>Try to establish rapport with the interviewer by finding points of commonality (such as your virtual backgrounds, or how the office is decorated)</p>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <p>Speak clearly and take time to consider what you’re saying and why</p>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <p>Listen carefully to the interviewer and wait before speaking to avoid interrupting</p>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <p>Pay attention to nonverbal cues that might indicate that you've been speaking for too long, or you've gone off-topic</p>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <p>Maintain eye contact to give the interviewer the sense that you are engaged and not distracted</p>
                </div>
              </slide>

              <slide>
                <div class="slide">
                  <p>Ask relevant questions to get a better understanding of the department’s work culture and to learn how this could be a good skill-building opportunity for you</p>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons">
                <img
                  slot="hooper-prev"
                  src="@/assets/img/_ui/svg/carousel-back.svg"
                  alt="previous"
                  srcset=""
                >
                <img
                  slot="hooper-next"
                  src="@/assets/img/_ui/svg/carousel-next.svg"
                  alt="next"
                  srcset=""
                >
              </hooper-navigation>

              <hooper-pagination slot="hooper-addons"></hooper-pagination>
            </hooper>
          </div>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
